import { Component, Input } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { Deck, GameType, GetDecksResponse } from "@apiserver-rest/ponder-data-client-base";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { MagicSetDecksRowComponent } from "./magic-set-decks-row.component";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";

@Component({
    selector: "magic-set-decks",
    imports: [BusySpinComponent, MagicSetDecksRowComponent],
    templateUrl: "./magic-set-decks.component.html"
})
export class MagicSetDecksComponent {
    @Input({ required: true }) public setCode!: string;

    public isLoading: boolean = true;
    public loadingSuccess: boolean = false;
    public decks?: Deck[];

    public constructor(private ponderDataClient: PonderDataClient) {

    }

    public ngOnInit(): void {
        this.ponderDataClient.decksPrecon(GameType.Magic, this.setCode).subscribe({
            next: (response: GetDecksResponse) => {
                if (response.success) {
                    this.loadingSuccess = true;
                    this.decks = response.decks;
                    this.decks?.sort((a, b) => a.name!.localeCompare(b.name!));
                }
            }
        })
        .add(() => { this.isLoading = false; });
    }

    public isMobileScreen(): boolean {
        return isMobileScreen();
    }
}